import Vue from 'vue'
import { Howl, Howler } from 'howler';

var sounds_list = [];

var sounds = {

	play: function(name) {
		sounds_list[name].play();
	},

	stop: function(name) {
		sounds_list[name].stop();
	},

	set_sounds: function(active) {
		for (var i in sounds_list) {
			sounds_list[i].mute(!active)
		}
	},

	init: function() {
		sounds_list['tap'] = new Howl({
			src: [ require('../assets/sounds/tap.mp3') ],
			format: ['mp3'],
			volume: 0.5
		});
		sounds_list['chain'] = new Howl({
			src: [ require('../assets/sounds/chain.mp3') ],
			format: ['mp3'],
			volume: 0.15
		});
		sounds_list['special'] = new Howl({
			src: [ require('../assets/sounds/special.mp3') ],
			format: ['mp3'],
			volume: 0.5
		});
		sounds_list['draw'] = new Howl({
			src: [ require('../assets/sounds/draw.mp3') ],
			format: ['mp3'],
			volume: 0.5
		});
	}
}

export default sounds


// WEBPACK FOOTER //
// ./src/core/Sounds.js